import type { BanDich } from '../../types';
import type { viRpaWorkflow } from './workflow.vi';

export const enRpaWorkflow: Pick<BanDich, keyof typeof viRpaWorkflow> = {
  rpaProject: {
    moTa: 'OpenRPA projects on OpenCore and the workflows in each project.',
    tongProject: 'Total projects',
    tongProjectSub: 'Projects on OpenCore',
    tongWorkflow: 'Total workflows',
    tongWorkflowSub: 'Workflows in these projects',
    tim: 'Search projects / workflows...',
    xuatCsv: 'Export CSV',
    daXuat: 'Exported the project list.',
    daLamMoi: 'Reloaded the project list from OpenCore.',
    rong: 'No projects on OpenCore yet',
    rongMoTa: 'Create a project in OpenRPA Designer, then click Refresh.',
    rongLoc: 'No projects match the search',
    cotTen: 'Project',
    cotWorkflow: 'Workflows',
    cotCapNhat: 'Updated',
    chuaCoWorkflow: 'No workflows yet',
    themWorkflow: '+{{so}} workflows',
    xemChiTiet: 'View details',
    xemChiTietCua: 'View details of {{ten}}',
    csvTen: 'Project',
    csvId: 'OpenCore ID',
    csvWorkflow: 'Workflows',
    csvCapNhat: 'Updated',
    hopTieuDe: 'Project details · {{ten}}',
    hopMeta: 'OpenCore ID: {{id}} · updated {{luc}}',
    hopWorkflow: 'Workflows in the project ({{so}})',
    hopCotWorkflow: 'Workflow',
    hopCotId: 'OpenCore ID',
    hopCotCapNhat: 'Updated',
    hopRong: 'This project has no workflows on OpenCore yet.',
    userCoLicense: 'Users with a licence',
    licenseKhongTai: 'Could not load licences',
    licenseSapHet: 'Licences expiring soon',
    licenseSapHetSub: 'In the next {{so}} days',
    cotUserCap: 'Licensed users',
    hopCotUser: 'Used by',
    hopChuaCap: 'Not granted to anyone',
    hopLicense: 'Licensed users ({{so}})',
    hopChuaCoLicense: 'No user has a licence in this project',
    hopChuaCoLicenseMoTa: 'Grant one on the RPA licences screen: pick the project, then the workflows for the user.',
    hopCotUserLicense: 'User',
    hopCotLoai: 'Type',
    hopCotPhamVi: 'Workflows allowed',
    hopCotTrangThai: 'Status',
    hopCotHetHan: 'Expires',
  },
  rpaWorkflow: {
    moTa: 'Pick a workflow to see its steps, variables & arguments and details.',
    loai: {
      openrpa: 'OpenRPA',
      script: 'Script / API',
      openrpaTieuDe: 'Human-like UI flows (OpenRPA)',
      scriptTieuDe: 'Automated Script / API flows',
      openrpaMoTa:
        'Mimics a user working the interface; suits websites with anti-bot measures or CAPTCHA, or that need human-like clicks and typing.',
      scriptMoTa: 'Works directly through APIs, scripts or headless browsers; suits fast, stable, data-driven tasks.',
    },
    dangDung: 'flows in use',
    tim: 'Search workflows or projects...',
    locProject: 'Filter by project',
    tatCaProject: 'All projects',
    khongThuocProject: 'No project',
    thuocProject: 'Project: {{ten}}',
    rong: 'No workflows on OpenCore yet',
    rongMoTa: 'Workflows published from OpenRPA will appear here.',
    rongLoc: 'No matching workflows',
    xemBuoc: 'View steps',
    xemThongTin: 'View details',
    chonWorkflow: 'Pick a workflow in the left column',
    chonWorkflowMoTa: 'The workflow’s steps, arguments and variables will appear here.',
    loaiLuong: 'Flow type',
    catBot: 'The workflow is too large: only the first {{so}} steps are shown.',
    soBuoc: '{{so}} steps',
    hienBuoc: 'Show steps',
    anBuoc: 'Hide steps',
    chuaCoBuoc: 'This workflow has no steps yet.',
    danhSachBuoc: 'Steps of {{ten}}',
    moWorkflowCon: 'Open child workflow',
    tabThuocTinh: 'Step properties',
    tabGiaTri: 'Variables & arguments',
    tabThongTin: 'Details',
    chonBuoc: 'Pick a step in the step list to see its properties.',
    tenBuoc: 'Step name',
    loaiActivity: 'Activity type',
    maBuoc: 'Step ID (IdRef)',
    workflowCon: 'Child workflow',
    cotThuocTinh: 'Property',
    cotGiaTri: 'Value',
    captionThuocTinh: 'Properties of step {{ten}}',
    khongThuocTinh: 'This step has no properties set.',
    ttTen: 'Workflow name',
    ttProject: 'Project',
    ttCapNhat: 'Updated',
    ttId: 'Workflow ID',
    ttNguoiCapNhat: 'Updated by',
    ttMoTa: 'Description',
    ttSoBuoc: 'Steps',
    ttCon: 'Child workflows called',
  },
  rpaGiaTri: {
    tim: 'Search variable, argument or block names',
    locLoai: 'Filter by kind',
    tatCaLoai: 'All kinds',
    thamSo: 'Argument',
    bien: 'Variable',
    huongIn: 'In argument',
    huongOut: 'Out argument',
    huongInOut: 'In/out argument',
    huongProperty: 'Property',
    chiCoGiaTri: 'Only items with a value',
    lichSu: 'Edit history',
    hoanTac: 'Undo',
    luuSo: 'Save {{so}} changes',
    cotTen: 'Name',
    cotLoai: 'Kind',
    cotKieu: 'Type',
    cotGiaTri: 'Default value',
    caption: 'Variables and arguments of {{ten}}',
    trong: 'In: {{pham}}',
    daSua: 'Edited',
    khongDat: 'Not set',
    biMatGiu: 'Has a value, leave empty to keep it',
    biMatTrong: 'No value yet',
    biMatMoi: 'new value (hidden)',
    loiBoolean: 'Only True or False.',
    loiInteger: 'Must be a whole number.',
    loiNumber: 'Must be a number, with a dot for decimals.',
    lyDoEXPRESSION: 'Expression, edit it in OpenRPA Designer',
    lyDoTYPE: 'Edit this type in OpenRPA Designer',
    lyDoOUT_ARGUMENT: 'Out argument, has no default value',
    lyDoCOMPLEX: 'Edit it in OpenRPA Designer',
    rong: 'This workflow has no variables or arguments',
    rongLoc: 'No items match the filters',
    xacNhanTieuDe: 'Save {{so}} changes to the workflow?',
    xacNhanThan: 'Robots use the new values from the next run. The current version is kept and can be restored from Edit history.',
    luuVao: 'Save to workflow',
    daLuu: 'Saved {{so}} changes to the workflow.',
    lichSuTieuDe: 'Variables & arguments edit history',
    lichSuRong: 'No edits from Native yet',
    banLuu: {
      edit: 'Edit',
      restore: 'Restore',
    },
    khoiPhucTu: 'Restored to the version from {{luc}}',
    khoiPhucTruoc: 'Restore to before this edit',
    khoiPhucHoi: 'Restore the workflow to the version before the edit at {{luc}}? The current values are still kept in the history.',
    khoiPhuc: 'Restore workflow',
    daKhoiPhuc: 'Restored the workflow.',
  },
  rpaChay: {
    batDau: 'Start',
    dangChay: 'Running',
    dangChayTren: 'Robot {{robot}} is running this workflow',
    chonProjectTieuDe: 'Run workflow {{ten}}',
    chonProjectMoTa: 'This workflow may run in several projects. Pick the project to run in:',
    project: 'Project to run in',
    chonProject: 'Pick a project',
    chay: 'Run workflow',
    khongCoProject: 'No project may run this workflow with a valid licence for the robot.',
    xong: 'Workflow {{ten}} finished.',
    loi: 'Workflow {{ten}} failed. See details in Run history.',
    matDau: 'No result received for workflow {{ten}}. Check its status in Run history.',
    ketNoi: 'Connect OpenCore',
    hopTieuDe: 'Connect an OpenCore account',
    taiKhoan: 'OpenCore account',
    matKhau: 'Password',
    ghiChu: 'Use the account signed in to OpenRPA on the robot machine. Native does not store the password.',
    nutKetNoi: 'Connect',
    daKetNoi: 'Connected OpenCore account {{ten}}.',
    taiKhoanDangKetNoi: 'Connected OpenCore account: {{ten}}',
    chayTren: 'Runs on robot {{ten}} · {{trangThai}}',
    online: 'online',
    offline: 'offline',
    chuaRo: 'status unknown',
    hetHan: 'connection expired',
    ketNoiLai: '{{ten}} · reconnect',
    doiTaiKhoan: 'Switch account',
    dangXuat: 'Sign out',
    daDangXuat: 'Signed out of the OpenCore account.',
  },
};
